type SectionProps = {
  className?: string;
  children?: React.ReactNode;
};

export const Section: React.FC<SectionProps> = ({ className, children }) => {
  return (
    <section className={`flex h-full w-full flex-col justify-between p-5 sm:pt-5 ${className}`}>
      {children}
    </section>
  );
};

export default Section;
